export default __webpack_public_path__ + "04e34ed7b9c2a62edb935e18009461c8.svg";